// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3hEpQ","productName":"Table_productName__1zOZQ"};